export const nl = {
    // Login screen
    modal_login_capital: 'MELD AAN',
    placeholder_email_address: 'label e-mail',
    placeholder_password: 'label paswoord',
    tooltip_forgot_password: 'Paswoord vergeten?',
    log_in: 'Aanmelden',

    // Register screen
    modal_signup_capital: 'INSCHRIJVEN',
    placeholder_repeat_password: 'herhaal paswoord',
    agree: 'Ik ga akkoord met de ',
    terms: 'Voorwaarden',
    modal_register_capital: 'REGISTREER',
    full_name: 'Volledige naam',

    // Price options
    choose_price: 'KIES UW PRIJS',
    subscription_price: 'Abonnement',
    asset_price: 'winst',
    paywall_subscription_text:
        'U kan uw abonnement ten allen tijde ongedaan maken.',
    modal_back: 'TERUG',
    next_button: 'VOLGENDE',

    // Payments screen
    pay: 'BETAAL',
    pay_with: 'BETAAL MET PAYPAL',
    credit_card: 'kredietkaart',
    payment_pay: 'Betaal',
    payment_price: 'Prijs',
    placeholder_voucher_code: 'vouchercode',
    placeholder_voucher: 'voucher toevoegen',
    card_number: 'kaartnummer',
    cardholder_name: 'naam kaarthouder',

    // Forgot password
    forgot_pass_text:
        'We sturen u een link om uw paswoord opnieuw in te stellen.',
    remember_pass: 'Paswoord onthouden?',
    reset: 'RESETTEN',

    // Set new password
    modal_enter_your_new_password: 'Geef uw paswoord in.',
    modal_please_check_your_email:
        'Gelieve uw e-mail te controleren en de token te kopiëren om verder te gaan.',
    placeholder_token: 'token',
    new_password: 'nieuw paswoord',
    repeat_new_password: 'herhaal nieuw paswoord',
    cancel: 'annuleer',
    set: 'INSTELLEN',

    // Change password
    update: 'updaten',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'Mijn account',
    member_since: 'Lid sinds',
    purchases: 'Mijn aankopen',
    subscriptions: 'Mijn abonnementen',
    account_details: 'Accountgegevens',
    export_data: 'Mijn data exporteren',
    delete_account: 'Account verwijderen',

    // Purchases/Subscriptions
    purchases_link: 'Aankopen',
    subscriptions_link: 'Abonnementen',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Aankoopgeschiedenis',
    purchased: 'Aangekocht',
    name: 'naam',
    active: 'actief',
    inactive: 'Inactive',
    canceled: 'geannuleerd',
    type: 'Type',
    next_transaction: 'Volgende transactie',
    cancel_subscription: 'Abonnement annuleren >',
    subscriptions_active: 'Actieve abonnementen',
    expires_at: 'Verloopt op',
    no_more_subscriptions: 'Er zijn geen abonnementen meer.',
    no_available_subscriptions: 'Er zijn geen beschikbare abonnementen.',
    no_more_active_accesses: 'Er zijn geen actieve toegangen meer.',
    no_more_inactive_accesses: 'Er zijn geen inactieve toegangen meer.',
    no_available_active_accesses: 'Er zijn geen beschikbare actieve toegangen.',
    no_available_inactive_accesses:
        'Er zijn geen beschikbare inactieve toegangen.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question: 'Bent u zeker dat u uw data wenst te exporteren?',
    export: 'exporter',
    first_export:
        'De accountgegevens exporteeractie zal alle persoonlijke gegevens van uw account exporteren, met name:',
    second_export: 'Uw persoonlijke informatie',
    third_export: 'De lijst van uw logins',
    fourth_export: 'De lijst van uw abonnementen',
    fifth_export: 'De lijst van uw betalingen',
    sixth_export: 'De lijst van uw toegangen tot premium inhoud',
    last_export: 'The export will be sent to your email address as attachment.',

    // Delete account screen
    delete_question: 'Bent u zeker dat u uw account wenst te verwijderen?',
    delete: 'verwijder',
    confirm: 'BEVESTIG',
    first_delete:
        'Door het verwijderen van uw account zullen uw persoonlijke gegevens uit het systeem worden verwijderd, met name: ',
    second_delete:
        'Persoonlijke informatie die u heeft verstrekt tijdens het registratieproces',
    third_delete:
        'Locatie- en apparaatinformatie die wij verzamelden tijdens het authenticatieproces',
    fourth_delete:
        'Alle andere persoonlijke informatie die is opgeslagen in andere delen van onze database',
    fifth_delete:
        'De enige persoonlijke gegevens die we in het systeem bewaren, zijn degene die deel uitmaken van de transacties en abonnementen in het kader van de naleving van de toepasselijke wetgeving.',
    sixth_delete:
        'Naast het wissen van uw persoonlijke gegevens wordt uw account ook gedesactiveerd, hetgeen betekent dat al uw actieve abonnementen worden geannuleerd, dat alle actieve toegangen tot activa worden ingetrokken en dat al uw actieve inlogsessies – inclusief deze – worden beëindigd. U zal zich niet langer kunnen authenticeren of activa aankopen op de website. Uw accountgegevens zullen niet langer beschikbaar zijn in de lijst van onze medewerkers.',
    seventh_delete:
        'Het kan 1 à 2 dagen duren vooraleer deze actie voltooid is, waarna een bevestigingsbericht naar uw e-mailadres zal worden gestuurd. De e-mail wordt na succesvolle aflevering uit ons systeem verwijderd.',

    // Inputs validation
    required_field: 'Verplicht veld',
    email_field: 'geef een correct e-mailadres in',
    number_field: 'Waarde moet een cijfer zijn',
    matchPass: 'het paswoord is niet correct',
    minpass_field: 'moet minstens 8 karakters tellen',
    minname_field: 'moet minstens 2 karakters tellen',

    // Footer
    modal_terms: 'Voorwaarden',
    modal_privacy: 'Privacy',
    modal_more: 'MEER',
    modal_faq: 'FAQ',
    modal_protected: 'Wat is dit?',
    logout: 'Uitloggen',
    details: 'mijn gegevens',
    preview_protected_by_inplayer: 'Beschermd door',
    modal_support: 'Support',

    dlc_download: 'download',
};



// WEBPACK FOOTER //
// ./src/i18n/dutch.js